import { Dispatch } from "redux";

import { ACTIONS } from "./types";
import store from "config/store";
import { RecommendsApi } from "api-client";
import { getAuthConfiguration } from "utils/getAuthConfiguration";

export const getRecommends = () => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const recommendsApi = new RecommendsApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_RECOMMENDS_REQUEST,
        });
        const res = await recommendsApi.getRecommendsApiRecommendsGet();
        dispatch({
            type: ACTIONS.GET_RECOMMENDS_SUCCESS,
            payload: res,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_RECOMMENDS_FAILURE,
        });
        throw e;
    }
};
